import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { SearchFiltersOptionTypesEnum } from '../enums/SearchFiltersOptionTypesEnum';

export const getSearchString = (state: IRootState) => state.search.searchString;
export const getSearchResultsData = (state: IRootState) => state.search.resultsData;
export const getSearchOrder = (state: IRootState) => state.search.order;
export const getSearchTotal = (state: IRootState) => state.search.total;
export const getSearchPage = (state: IRootState) => state.search.page;
export const getSearchTotalPages = (state: IRootState) => state.search.totalPages;
export const getSearchFilter = (state: IRootState) => state.search.filter;
export const getSearchFilterOptionByType = (state: IRootState, optionType: SearchFiltersOptionTypesEnum) => {
  const options = state.search.filterOptions?.[optionType]?.data;

  if (optionType === SearchFiltersOptionTypesEnum.TYPE_OF_STATE_SUPERVISION && options) {
    return options.map(option => ({
      ...option,
      label: `${option.id} - ${option.value}`,
    }));
  }

  return options;
};
